
import { axios } from "../core/axios.interceptor";

export async function bookExpert() {
  const response = await axios.post("book-expert");
  return response;
}